/*
 * Shop, grouped view (sections/ex-shop.liquid on /collections/all): the rail marks the section
 * in view (aria-current="true") and keeps that entry visible in the rail. Progressive only:
 * without this file the rail entries are plain #anchors and still jump to their section.
 * One click and one scroll listener for the page's life; init() only swaps the state they read,
 * so the theme editor's shopify:section:load (any section) never stacks listeners.
 */
(function () {
  var io = null, rail = null, links = [];

  function mark(id) {
    links.forEach(function (a) {
      if (a.getAttribute("href") === "#" + id) {
        a.setAttribute("aria-current", "true");
        // Keep the current entry in the rail's own view; never scroll the page for it.
        var top = a.offsetTop, bottom = top + a.offsetHeight;
        if (top < rail.scrollTop || bottom > rail.scrollTop + rail.clientHeight) rail.scrollTop = top;
      } else {
        a.removeAttribute("aria-current");
      }
    });
  }

  function idOf(a) { return a.getAttribute("href").slice(1); }

  // At the very bottom of a page that scrolls, the last section is the one in view however
  // short it is. A page too short to scroll never counts as "at the bottom".
  function atBottom() {
    var h = document.documentElement.scrollHeight;
    return h > window.innerHeight + 2 && window.innerHeight + window.scrollY >= h - 2;
  }

  function init() {
    if (io) { io.disconnect(); io = null; }
    rail = null; links = [];
    var r = document.querySelector(".ex-rail[data-ex-spy]");
    if (!r || !("IntersectionObserver" in window)) return;
    var found = Array.prototype.filter.call(r.querySelectorAll("a[href^='#ex-sec-']"), function (a) {
      return document.getElementById(idOf(a));
    });
    if (!found.length) return;
    rail = r; links = found;

    var visible = {};
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting; });
      if (atBottom()) { mark(idOf(links[links.length - 1])); return; }
      // The first section, in page order, whose top band is on screen.
      for (var i = 0; i < links.length; i++) {
        if (visible[idOf(links[i])]) { mark(idOf(links[i])); return; }
      }
    }, { rootMargin: "-15% 0px -70% 0px" });
    links.forEach(function (a) { io.observe(document.getElementById(idOf(a))); });
    mark(idOf(links[0]));
  }

  // A tap marks its entry at once: a short last section may never reach the band above.
  document.addEventListener("click", function (e) {
    if (!rail || !e.target.closest) return;
    var a = e.target.closest("a[href^='#ex-sec-']");
    if (a && links.indexOf(a) !== -1) mark(idOf(a));
  });
  window.addEventListener("scroll", function () {
    if (rail && atBottom()) mark(idOf(links[links.length - 1]));
  }, { passive: true });

  init();
  document.addEventListener("shopify:section:load", init);
})();
